import privateAxios from "../utils/axiosPrivate";
import { activityLogURL } from "../utils/constants/apiEndPoints";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  loading: false,
  error: null
};

// Slice
const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    setCustomersLoading(state, action) {
      state.loading = action.payload;
    },
    setCustomersError(state, action) {
      state.error = action.payload;
    }
  }
});

// Thunk: get customer list
export const activityListThunk = createAsyncThunk(
  "activity/getCustomerList",
  async (payload, { dispatch }) => {
    try {
      dispatch(setCustomersLoading(true));

      const response = await privateAxios.get(activityLogURL, {
        params: payload
      });

      return response;
    } catch {
      // handle catch here;
    } finally {
      dispatch(setCustomersLoading(false));
    }
  }
);

// Actions & Reducer
export const { setCustomers, setCustomersLoading, setCustomersError } =
  activitySlice.actions;

export default activitySlice.reducer;
